var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 6.95241L17.0492 10.5524M4.44922 19.5524L8.8152 18.6727C9.04698 18.626 9.2598 18.5119 9.42693 18.3446L19.2006 8.56559C19.6692 8.09674 19.6689 7.33675 19.1999 6.86829L17.1295 4.80021C16.6607 4.33194 15.9011 4.33226 15.4327 4.80092L5.65798 14.581C5.49117 14.7479 5.37727 14.9603 5.33052 15.1916L4.44922 19.5524Z",
    stroke: "#1F75A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/ProfileEdit.5d8b67fcbe8e51b33f0e6c001a524f35.svg";
export { ForwardRef as ReactComponent };